// src/app/shared/user-data.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private buildingId: string | null = null;
  private contact: any | null = null; 
  private hasAssess: string | null = null;
  private userAssessPermission: string | null = null;
  private regionId: string | null = null;

  setBuildingId(buildingId: string): void {
    this.buildingId = buildingId;
  }

  setCurrentUser(contact: any): void {
    this.contact = contact;
  }

  setAssessStatus(hasAssess: string): void {
    this.hasAssess = hasAssess;
  }

  setUserAssessPermission(permission: string): void {
    this.userAssessPermission = permission;
  }

  setRegionId(regionId: string): void {
    this.regionId = regionId;
  }

  getBuildingId(): string | null {
    return this.buildingId;
  }

  getCurrentUser(): any | null {
    return this.contact;
  }

  getHasAssess(): string | null {
    return this.hasAssess;
  }

  getUserAssessPermission(): string | null {
    return this.userAssessPermission;
  }

  getRegionId(): string | null {
    return this.regionId;
  }
}
